import React from 'react';
import './SiteFooter.css';

export default function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="footer-grid">
        {/* Product */}
        <div className="footer-col">
          <h4>Header 1</h4>
          <a href={process.env.REACT_APP_BASEURL}>Option 1</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 2</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 3</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 4</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 5</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 6</a>

          <h4 className="footer-subtitle">Header 2</h4>
          <a href={process.env.REACT_APP_BASEURL}>Option 1</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 2</a>
        </div>

        {/* Use Cases */}
        <div className="footer-col">
          <h4>Header 3</h4>
          <a href={process.env.REACT_APP_BASEURL}>Option 1</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 2</a>

          <h4 className="footer-subtitle">Header 4</h4>
          <a href={process.env.REACT_APP_BASEURL}>Option 1</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 2</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 3</a>
        </div>

        {/* Features */}
        <div className="footer-col">
          <h4>Header 5</h4>
          <a href={process.env.REACT_APP_BASEURL}>Option 1</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 2</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 3</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 4</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 5</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 6</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 7</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 8</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 9</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 10</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 11</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 12</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 13</a>
        </div>

        {/* Company */}
        <div className="footer-col">
          <h4>Header 6</h4>
          <a href={process.env.REACT_APP_BASEURL}>Option 1 <span className="badge">We’re hiring!</span></a>
          <a href={process.env.REACT_APP_BASEURL}>Option 2</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 3</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 4</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 5</a>

          <h4 className="footer-subtitle">Header 7</h4>
          <a href={process.env.REACT_APP_BASEURL}>Option 1</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 2</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 3</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 4</a>
          <a href="javascript:void(0)" className="status">
            <span className="status-dot" />
            Option 5
          </a>
          <a href="javascript:void(0)" className="github">
            Option 6 <span className="star">45k ★</span>
          </a>
        </div>

        {/* Resources */}
        <div className="footer-col">
          <h4>Header 8</h4>
          <a href={process.env.REACT_APP_BASEURL}>Option 1</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 2</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 3</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 4</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 5</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 6</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 7</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 8</a>
          <a href={process.env.REACT_APP_BASEURL}>Option 9</a>
        </div>
      </div>

      <div className="footer-bottom">
        <span className="copyright">
          © Scope Console 2025
        </span>

        {/* <div className="socials">
          <span>YouTube</span>
        </div> */}
      </div>
    </footer>
  );
}
